// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DPRG","content":"styles_content__1bZsz","tableWrap":"styles_tableWrap__12HnJ"};